import { ChangeEvent, useRef } from "react";
import {
  FileInputButtonWraper,
  HiddenFileInput,
} from "./messageAttachment.styles";
import { Icon, Button as MindlerButton } from "@mindlercare/ui-web";
import { Typography } from "components/typography";
import { useTranslation } from "react-i18next";
import {
  SupportedFileExtensions,
  supportedFileExtensions,
} from "@mindlercare/schema";

type Props = {
  onChange: (event: ChangeEvent<HTMLInputElement>) => Promise<void>;
};

const supportedFileFormats =
  supportedFileExtensions.map<`.${SupportedFileExtensions}`>(
    (ext) => `.${ext}`,
  );

const acceptedFileFormats = supportedFileFormats.join(", ");

export const FileUploader = ({ onChange }: Props) => {
  const { t } = useTranslation();

  const fileInputRef = useRef<HTMLInputElement | null>(null);

  const triggerFileInputClick = () => {
    if (fileInputRef.current) {
      fileInputRef.current.click();
    }
  };

  return (
    <form action="/upload" method="post" encType="multipart/form-data">
      <HiddenFileInput
        type="file"
        hidden
        name="attachment"
        multiple
        onChange={onChange}
        ref={fileInputRef}
        accept={acceptedFileFormats}
      />
      <FileInputButtonWraper>
        <MindlerButton
          variant="secondary-small"
          onClick={triggerFileInputClick}
        >
          <Icon.Add style={{ marginRight: "4px" }} />
          <Typography variant="body-small">
            {t("MESSAGE_ATTACHMENT_ADD_FILE_BUTTON")}
          </Typography>
        </MindlerButton>
        <Typography variant="body-x-small" color="DARK_GREY">
          {t("MESSAGE_ATTACHMENT_ADD_FILE_DESCRIPTION", {
            fileFormats: acceptedFileFormats,
          })}
        </Typography>
      </FileInputButtonWraper>
    </form>
  );
};
